import react from 'react';





export default function () {
    return (

        <section className="blocksBg">
        <div className="uk-container">
           
    
                <div className="uk-width-1-1 uk-padding uk-margin-medium-top">
                          <div className="uk-flex uk-flex-center">
                            <div className="mediumContainer">
                                <h1 className=" header1 uk-text-center">Why choose <span className="greenText">Virtual 1-on-1</span> Computer Courses</h1>
                                <p className="uk-text-center normalPaddingLR">Let us boost your child’s creativity and tech skill set to design their
                                     own games or video animation. Students dive into the universe of Minecraft,
                                    Roblox or Scratch to explore 3D architecture and game challenges. Get them 
                                    ready with personalized tech education.</p>
                            </div>
                         </div>
                </div>





                  
                  
                       
                 <div className="uk-flex uk-flex-center ">
                    <div className="mediumContainerLarge">
                        <div class="uk-child-width-expand@s uk-text-center" data-uk-grid>

                        <div>
                            <div class="uk-card height300 uk-card-default borderRadius  uk-card-body">
                                <h6 className="uk-text-bold uk-text-center uk-margin-top greenText">Tech Expert Teachers</h6>
                                <p className="uk-text-center smallText">Our teachers come with expertise and experience and put it in the 
                                    service of your child. Their passion for tech boosts results and makes learning fun.</p>
                            </div>
                        </div>


                        <div>
                            <div class="uk-card height300 uk-card-default borderRadius uk-card-body">
                            <h6 className="uk-text-bold uk-text-center uk-margin-top greenText">Customized tech pathway for your child</h6>
                                <p className="uk-text-center smallText">1-on-1 time and attention to create the best and fastest way of building in-demand 
                                tech skills. Many course options tailored to fit every student that joins us.</p>   
                            </div>
                        </div>


                        <div>
                            <div class="uk-card height300 uk-card-default borderRadius  uk-card-body">

                            <h6 className="uk-text-bold uk-text-center  uk-margin-top greenText">Flexible scheduling and financial options</h6>
                                <p className="uk-text-center smallText">Enjoy rates and time slots to fit your demands. Get as many hours as you want, when
                                 you need them. Go Virtual for ultimate mobility.</p>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>




                     {/***Second row**/}
                     
                 <div className="uk-flex uk-flex-center uk-margin-medium-top uk-margin-large-bottom">
                    <div className="mediumContainerLarge">
                        <div class="uk-child-width-expand@s uk-text-center" data-uk-grid>

                        <div>
                            <div class="uk-card height300 uk-card-default borderRadius uk-card-body">
                                <h6 className="uk-text-bold uk-text-center uk-margin-top greenText">The future is Tech and fun</h6>
                                <p className="uk-text-center smallText">Creativity and programming principles are essential for the 
                                next generation. Our students have fun tapping into their creative side with everything from Minecraft to Python.</p>
                            </div>
                        </div>


                        <div>
                            <div class="uk-card height300 uk-card-default borderRadius uk-card-body">
                            <h6 className="uk-text-bold uk-text-center uk-margin-top  greenText">Learn @home or anywhere</h6>
                                <p className="uk-text-center smallText">Flexibility is now essential. Education doesn’t have to
                                 stop. We bring you the chance to learn from anywhere.</p>   
                            </div>
                        </div>


                        <div>
                            <div class="uk-card height300 uk-card-default borderRadius uk-card-body">

                            <h6 className="uk-text-bold  uk-text-center uk-margin-top  greenText">Schools partner up with us</h6>
                                <p className="uk-text-center smallText">Education providers support tech education. We teamed
                                 up with Schools to offer our computer courses and add value to your child’s academic path.</p>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>


           
            </div>
            </section>
    );
}